import { createSlice } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';

const initialState = {
  errorContent: {},
  aadharKycOption: false,
  addharUploadPageDetails: {
    aadharUploadFlag: false,
    docType: '',
  },
  kycJourneyFirst: true,
  currentScreen: '',
  previousScreen: '',
  globalOverlayLoader: false,
  oKycFlag: false,
  panyDropFlagDetails: {
    panyDropFlag: false,
    docType: '',
  },
  isHypervergeKycLoading: 0, // default page 0, 1 means success screen ,2 = loder
  userInputs: {
    img1: '',
    img2: '',
    imgPath1: '',
    imgPath2: '',
    forcePush1: 1,
    forcePush2: 1,
    idNumber: '',
    idNumberErr: '',
    errMsg1: '',
    errMsg2: '',
    successMsg1: '',
    successMsg2: '',
    expDate: '',
    expErr: '',
  },
  okyFromData: {
    aadharNo: '',
    securityCode: '',
    termCheck: false,
  },
  panyDropResponseMessage: '',
  okyPayload: {},
};

export const kycSlice = createSlice({
  name: 'kyc',
  initialState,
  reducers: {
    upodateErrorContent: (state, action) => {
      state.errorContent = action.payload;
    },
    upodateAadharKycOption: (state, action) => {
      state.aadharKycOption = action.payload;
    },
    updateDocTypeDetails: (state, action) => {
      state.addharUploadPageDetails = action.payload;
    },
    updateKycJourneyFirst: (state, action) => {
      state.kycJourneyFirst = action.payload;
    },
    updateCurrentScreen: (state, action) => {
      state.currentScreen = action.payload;
    },
    updatePreviousScreen: (state, action) => {
      state.previousScreen = action.payload;
    },
    updateGlobalOverlayLoader: (state, action) => {
      state.globalOverlayLoader = action.payload;
    },
    updateOkycFlag: (state, action) => {
      state.oKycFlag = action.payload;
    },
    updatePainyDropDocTypeDetails: (state, action) => {
      state.panyDropFlagDetails = action.payload;
    },
    updateHypervergeKycLoading: (state, action) => {
      state.isHypervergeKycLoading = action.payload;
    },
    updateInputs: (state, action) => {
      state.userInputs = { ...state.userInputs, ...action.payload };
    },
    updatePanyDropResponseMessage: (state, action) => {
      state.panyDropResponseMessage = action.payload;
    },
    updateOkycFromData: (state, action) => {
      state.okyFromData = action.payload;
    },
    updateOkycPayload: (state, action) => {
      state.okyPayload = action.payload;
    },
    resetInputs: (state) => {
      state.userInputs = {
        img1: '',
        img2: '',
        imgPath1: '',
        imgPath2: '',
        forcePush1: 1,
        forcePush2: 1,
        idNumber: '',
        idNumberErr: '',
        errMsg1: '',
        errMsg2: '',
        successMsg1: '',
        successMsg2: '',
        expDate: '',
        expErr: '',
      };
    },
  },
});

export function useKycStore() {
  const errorContent = useSelector((state) => state.kyc.errorContent);
  const aadharKycOption = useSelector((state) => state.kyc.aadharKycOption);
  const addharUploadPageDetails = useSelector(
    (state) => state.kyc.addharUploadPageDetails
  );
  const kycJourneyFirst = useSelector((state) => state.kyc.kycJourneyFirst);
  const currentScreen = useSelector((state) => state.kyc.currentScreen);
  const previousScreen = useSelector((state) => state.kyc.previousScreen);
  const oKycFlag = useSelector((state) => state.kyc.oKycFlag);
  const globalOverlayLoader = useSelector(
    (state) => state.kyc.globalOverlayLoader
  );

  const panyDropFlagDetails = useSelector(
    (state) => state.kyc.panyDropFlagDetails
  );
  const isHypervergeKycLoading = useSelector(
    (state) => state.kyc.isHypervergeKycLoading
  );
  const userInputs = useSelector((state) => state.kyc.userInputs);
  const panyDropResponseMessage = useSelector(
    (state) => state.kyc.panyDropResponseMessage
  );
  const okyFromData = useSelector((state) => state.kyc.okyFromData);
  const okyPayload = useSelector((state) => state.kyc.okyPayload);
  const dispatch = useDispatch();

  return {
    errorContent,
    aadharKycOption,
    addharUploadPageDetails,
    kycJourneyFirst,
    currentScreen,
    previousScreen,
    globalOverlayLoader,
    oKycFlag,
    panyDropFlagDetails,
    isHypervergeKycLoading,
    userInputs,
    panyDropResponseMessage,
    okyFromData,
    okyPayload,
    upodateErrorContent: (payload) => dispatch(upodateErrorContent(payload)),

    upodateAadharKycOption: (payload) =>
      dispatch(upodateAadharKycOption(payload)),

    updateDocTypeDetails: (payload) => dispatch(updateDocTypeDetails(payload)),

    updateKycJourneyFirst: (payload) =>
      dispatch(updateKycJourneyFirst(payload)),

    updateCurrentScreen: (payload) => dispatch(updateCurrentScreen(payload)),

    updatePreviousScreen: (payload) => dispatch(updatePreviousScreen(payload)),
    updatePanyDropResponseMessage: (payload) =>
      dispatch(updatePanyDropResponseMessage(payload)),

    updateGlobalOverlayLoader: (payload) =>
      dispatch(updateGlobalOverlayLoader(payload)),
    updateOkycFlag: (payload) => dispatch(updateOkycFlag(payload)),
    updatePainyDropDocTypeDetails: (payload) =>
      dispatch(updatePainyDropDocTypeDetails(payload)),
    updateHypervergeKycLoading: (isLoading) =>
      dispatch(updateHypervergeKycLoading(isLoading)),
    updateInputs: (payload) => dispatch(updateInputs(payload)),
    resetInputs: () => dispatch(resetInputs()),
    updateOkycFromData: (payload) => dispatch(updateOkycFromData(payload)),
    updateOkycPayload: (payload) => dispatch(updateOkycPayload(payload)),
  };
}

export const {
  upodateErrorContent,
  upodateAadharKycOption,
  updateDocTypeDetails,
  updateKycJourneyFirst,
  updateCurrentScreen,
  updatePreviousScreen,
  updateGlobalOverlayLoader,
  updateOkycFlag,
  updatePainyDropDocTypeDetails,
  updateInputs,
  resetInputs,
  updateHypervergeKycLoading,
  updatePanyDropResponseMessage,
  updateOkycFromData,
  updateOkycPayload,
} = kycSlice.actions;

export default kycSlice.reducer;
